export const DNA_DATE_REPLACE_TRANSLATION_KEY = '{date}'
